/**
 * Audiated Logo Component
 *
 * Clean, readable "Audiated" text with sound wave and music note styling.
 * Features smooth animations and brand-appropriate colors.
 */

import React from 'react';
import styles from './AudiatedLogo.module.css';

interface AudiatedLogoProps {
  /** Size variant for different contexts */
  variant?: 'header' | 'footer' | 'mobile' | 'small';
  /** Optional custom className */
  className?: string;
  /** Whether to show animations */
  animated?: boolean;
}

const AudiatedLogo: React.FC<AudiatedLogoProps> = ({
  variant = 'header',
  className = '',
  animated = true
}) => {
  return (
    <div className={`${styles.logo} ${styles[variant]} ${className}`}>
      <div className={`${styles.textContainer} ${animated ? styles.animated : ''}`}>
        <span className={styles.soundWave}>
          <div className={styles.waveLine}></div>
          <div className={styles.waveLine}></div>
          <div className={styles.waveLine}></div>
          <div className={styles.waveLine}></div>
          <div className={styles.waveLine}></div>
        </span>
        <span className={styles.text}>
          <span className={`${styles.letter} ${styles.letterDelay1}`}>A</span>
          <span className={`${styles.letter} ${styles.letterDelay2}`}>u</span>
          <span className={`${styles.letter} ${styles.letterDelay3}`}>d</span>
          <span className={`${styles.letter} ${styles.letterDelay4}`}>i</span>
          <span className={`${styles.letter} ${styles.letterDelay5}`}>a</span>
          <span className={`${styles.letter} ${styles.letterDelay6}`}>t</span>
          <span className={`${styles.letter} ${styles.letterDelay7}`}>e</span>
          <span className={`${styles.letter} ${styles.letterDelay8}`}>d</span>
        </span>
      </div>
    </div>
  );
};

export default AudiatedLogo;